import { derived, writable } from "svelte/store";

export interface DwollaIdentityStore {
  payment_identity: {};
  provider: {
    customer_verification_status: string;
  };
  loaded: boolean;
  failed: boolean;
}

const defaultDwollaIdentityStore: DwollaIdentityStore = {
  payment_identity: null,
  provider: null,
  loaded: false,
  failed: false,
};
export const dwollaIdentityStore = writable<DwollaIdentityStore>(defaultDwollaIdentityStore);

export const userDisabled = derived(dwollaIdentityStore, $dwollaIdentityStore =>
  ["suspended", "deactivated"].includes(
    $dwollaIdentityStore?.provider?.customer_verification_status,
  ),
);

export const userReactivated = derived(
  dwollaIdentityStore,
  $dwollaIdentityStore =>
    $dwollaIdentityStore?.provider?.customer_verification_status == "reactivated",
);
